(function () {
  'use strict';

  function getPreviewBarOffset() {
    var bar = document.getElementById('PBarNextFrameWrapper');
    if (!bar) return 0;
    return bar.getBoundingClientRect().height || 0;
  }

  var applying = false;
  function applyLayout(banner) {
    if (applying) return;
    applying = true;
    var s = banner.style;
    var isMobile = window.innerWidth <= 749;
    var previewOffset = getPreviewBarOffset();

    if (isMobile) {
      var baseBottom = window.innerWidth <= 480 ? 12 : 16;
      s.setProperty('position', 'fixed', 'important');
      s.setProperty('left', '50%', 'important');
      s.setProperty('right', 'auto', 'important');
      s.setProperty('top', 'auto', 'important');
      s.setProperty('bottom', (baseBottom + previewOffset) + 'px', 'important');
      s.setProperty('transform', 'translateX(-50%)', 'important');
      s.setProperty('margin', '0', 'important');
      s.setProperty('width', '320px', 'important');
      s.setProperty('max-width', 'calc(100vw - 32px)', 'important');
    } else {
      s.setProperty('position', 'fixed', 'important');
      s.setProperty('left', '0', 'important');
      s.setProperty('right', '0', 'important');
      s.setProperty('top', 'auto', 'important');
      s.setProperty('bottom', previewOffset + 'px', 'important');
      s.setProperty('transform', 'none', 'important');
      s.setProperty('margin', '0', 'important');
      s.setProperty('width', '100%', 'important');
      s.setProperty('max-width', '100%', 'important');
    }
    s.setProperty('z-index', '9999', 'important');
    applying = false;
  }

  /* One-way expand: clicking "Skaityti daugiau" reveals the full text and removes the
     toggle entirely -- there is no "Rodyti maziau" collapse-back state. */
  var toggleAdded = false;
  function addReadMoreToggle(banner) {
    if (toggleAdded) return;
    var body = banner.querySelector('.shopify-pc__banner__body');
    var para = body ? body.querySelector('p') : null;
    if (!para) return;
    toggleAdded = true;

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'nv2-pc-more-toggle';
    toggle.textContent = 'Skaityti daugiau';
    toggle.addEventListener('click', function () {
      para.classList.add('nv2-pc-expanded');
      toggle.remove();
    });
    para.insertAdjacentElement('afterend', toggle);
  }

  var CUSTOM_FULL_PREFIX = 'Mes naudojame slapukus, kad pagerintume jūsų patirtį, analizuotume srautą ir suasmenintume turinį. Kai kurie slapukai yra būtini, o kiti padeda mums suprasti, kaip sąveikaujate su mūsų svetaine. Bet kada galite valdyti savo nustatymus. Sužinokite daugiau mūsų ';

  var customApplied = false;
  function applyCustomText(banner) {
    if (customApplied) return;
    var body = banner.querySelector('.shopify-pc__banner__body');
    var para = body ? body.querySelector('p') : null;
    var link = para ? para.querySelector('a') : null;
    if (!para || !link) return;
    customApplied = true;

    var href = link.getAttribute('href');
    var linkText = link.textContent;

    var fullSpan = document.createElement('span');
    fullSpan.className = 'nv2-pc-full-text';
    fullSpan.appendChild(document.createTextNode(CUSTOM_FULL_PREFIX));
    var newLink = document.createElement('a');
    newLink.href = href;
    newLink.target = '_blank';
    newLink.rel = 'noopener noreferrer';
    newLink.textContent = linkText;
    fullSpan.appendChild(newLink);
    fullSpan.appendChild(document.createTextNode('.'));

    para.innerHTML = '';
    para.appendChild(fullSpan);
  }

  var relabelled = false;
  function relabelAccept(banner) {
    if (relabelled) return;
    var acceptBtn = banner.querySelector('#shopify-pc__banner__btn-accept');
    if (!acceptBtn) return;
    relabelled = true;
    if (acceptBtn.textContent.trim() === 'Priimti') {
      acceptBtn.textContent = 'Sutinku';
    }
  }

  var managePromoted = false;
  function promoteManageLink(banner) {
    if (managePromoted) return;
    var wrapper = banner.querySelector('.shopify-pc__banner__btns, .shopify-pc__banner__btn-wrapper');
    var body = banner.querySelector('.shopify-pc__banner__body');
    if (!wrapper) return;
    var manageEl = banner.querySelector('#shopify-pc__banner__btn-manage-prefs');
    if (!manageEl) {
      var candidates = banner.querySelectorAll('a, button');
      for (var i = 0; i < candidates.length; i++) {
        var el = candidates[i];
        if (el.id === 'shopify-pc__banner__btn-accept' || el.id === 'shopify-pc__banner__btn-decline') continue;
        if (body && body.contains(el)) continue;
        manageEl = el;
        break;
      }
    }
    if (!manageEl) return;
    managePromoted = true;
    manageEl.classList.add('nv2-pc-manage-btn');
    manageEl.textContent = 'Nustatymai';
    wrapper.appendChild(manageEl);
  }

  /* Uses the same X path Shopify's own preferences-panel close button ships (confirmed live
     in that panel's markup), instead of the '&times;' text character -- a text glyph has its
     own font-dependent optical bearing and never sits precisely centered in a flex box no
     matter how the box itself is centered; an SVG with a known, symmetric path does. */
  var CLOSE_ICON_SVG = '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path fill="currentColor" d="M7.41401 6.00012L11.707 1.70721C12.098 1.31622 12.098 0.684236 11.707 0.293244C11.316 -0.097748 10.684 -0.097748 10.293 0.293244L6.00001 4.58615L1.70701 0.293244C1.31601 -0.097748 0.684006 -0.097748 0.293006 0.293244C-0.0979941 0.684236 -0.0979941 1.31622 0.293006 1.70721L4.58601 6.00012L0.293006 10.293C-0.0979941 10.684 -0.0979941 11.316 0.293006 11.707C0.488006 11.902 0.744006 12 1.00001 12C1.25601 12 1.51201 11.902 1.70701 11.707L6.00001 7.4141L10.293 11.707C10.488 11.902 10.744 12 11 12C11.256 12 11.512 11.902 11.707 11.707C12.098 11.316 12.098 10.684 11.707 10.293L7.41401 6.00012Z"></path></svg>';

  var closeAdded = false;
  function addCloseButton(banner) {
    if (closeAdded) return;
    var declineBtn = banner.querySelector('#shopify-pc__banner__btn-decline');
    closeAdded = true;

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'nv2-pc-close-btn';
    closeBtn.setAttribute('aria-label', 'Uzdaryti');
    closeBtn.innerHTML = CLOSE_ICON_SVG;
    closeBtn.addEventListener('click', function () {
      if (declineBtn) declineBtn.click();
    });
    banner.appendChild(closeBtn);
  }

  var done = false;
  function enhance(banner) {
    applyLayout(banner);
    applyCustomText(banner);
    addReadMoreToggle(banner);
    relabelAccept(banner);
    promoteManageLink(banner);
    addCloseButton(banner);
    if (done) return;
    done = true;

    var styleObserver = new MutationObserver(function () {
      applyLayout(banner);
      applyCustomText(banner);
      addReadMoreToggle(banner);
      relabelAccept(banner);
      promoteManageLink(banner);
      addCloseButton(banner);
    });
    styleObserver.observe(banner, { attributes: true, childList: true, subtree: true });
    window.addEventListener('resize', function () { applyLayout(banner); });

    var checks = 0;
    var poll = setInterval(function () {
      applyLayout(banner);
      checks++;
      if (checks > 10) clearInterval(poll);
    }, 500);
  }

  var existing = document.getElementById('shopify-pc__banner');
  if (existing) {
    enhance(existing);
  } else {
    var observer = new MutationObserver(function () {
      var banner = document.getElementById('shopify-pc__banner');
      if (banner) {
        enhance(banner);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
